import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'tube-lotion',
  size: 24,
  node: [
    ['path', { d: 'M15 18v3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-3', key: 'b580kr' }],
    [
      'path',
      {
        d: 'M17 2a2 2 0 0 1 1.6 3.2A8 8 0 0 0 17 10v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-6a8 8 0 0 0-1.6-4.8A2 2 0 0 1 7 2z',
        key: 'ih942v',
      },
    ],
    ['path', { d: 'M7 10a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0', key: '1fwxph' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name TubeLotion
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTh2M2ExIDEgMCAwIDEtMSAxaC00YTEgMSAwIDAgMS0xLTF2LTMiIC8+CiAgPHBhdGggZD0iTTE3IDJhMiAyIDAgMCAxIDEuNiAzLjJBOCA4IDAgMCAwIDE3IDEwdjZhMiAyIDAgMCAxLTIgMkg5YTIgMiAwIDAgMS0yLTJ2LTZhOCA4IDAgMCAwLTEuNi00LjhBMiAyIDAgMCAxIDcgMnoiIC8+CiAgPHBhdGggZD0iTTcgMTBhNi40NyA2LjQ3IDAgMCAxIDUgMCA2LjQ3IDYuNDcgMCAwIDAgNSAwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/tube-lotion
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TubeLotion = createLucideIcon(__iconData);

export default TubeLotion;
